const header = document.querySelector(".shopify-section-group-header-group");
const bodyElement = document.querySelector("body");
let lastScrollPosition = 0;

window.addEventListener("scroll", () => {
  const currentScrollPosition = window.scrollY;
  const scrollTop = window.pageYOffset || document.documentElement.scrollTop; 
  const hash = window.location.hash;
  
  if (hash && hash.includes('storage-unit')) {
    if (scrollTop >= 200) {
      header.classList.add("sticky-header-cus");
      bodyElement.style.marginTop = "200px";
    } else if(currentScrollPosition > lastScrollPosition){
      bodyElement.style.marginTop = "0";
    } else {
      bodyElement.style.marginTop = "0";
    }
  } else {
    if (scrollTop >= 0) {
      header.classList.add("sticky-header-cus");
    } else {
      // header.classList.remove("sticky-header-cus");
    }
  }
  lastScrollPosition = currentScrollPosition;
});




document.addEventListener("DOMContentLoaded", function () {
  const videoBoxes = document.querySelectorAll(".video__box");

  videoBoxes.forEach((box) => {
    const video = box.querySelector("video");
    const playIcon = box.querySelector(".play-btn-hldr");

    box.addEventListener("click", () => {
      // pause other videos
      document.querySelectorAll(".video__box video").forEach((v) => {
        if (v !== video) v.pause();
      });

      // play or pause the clicked video
      if (video.paused) {
        video.play();
      } else {
        video.pause();
      }
    });

    // when video plays
    video.addEventListener("play", () => {
      playIcon.classList.add("hidden");
    });

    // when video pauses
    video.addEventListener("pause", () => {
      playIcon.classList.remove("hidden");
    });
  });
});


{
  document.addEventListener("DOMContentLoaded", function () {
    const allAccordions = document.querySelectorAll(
      ".faqs__rows .accordion_cus"
    );
    allAccordions.forEach((accordion) => {
      const items = accordion.querySelectorAll(".faqs__rows .acco_cus_item");
      if (items.length > 0) {
        items[0].classList.add("open");
      }
      items.forEach((item) => {
        const header = item.querySelector(".faqs__rows .acc-header");
        header.addEventListener("click", () => {
          items.forEach((otherItem) => {
            if (otherItem !== item && otherItem.classList.contains("open")) {
              otherItem.classList.remove("open");
            }
          });
          item.classList.toggle("open");
        });
      });
    });
  });
}

// {
//   document.addEventListener("DOMContentLoaded", function () {
//   const contactForms = document.querySelectorAll(".contact-form");

//   contactForms.forEach(function (form) {
//     const nextBtnSpan = form.querySelector(".next-bttn span");
//     const finalStep = form.querySelector(".final-step");
//     const oldstep = form.querySelector(".your-contact-info");
//     const backBtn = form.querySelector(".back_btns span");

//     if (nextBtnSpan && finalStep && oldstep) {
//       nextBtnSpan.addEventListener("click", function () {
//         finalStep.style.display = "flex";
//         oldstep.style.display = "none";
//       });
//     }

//     if (backBtn && finalStep && oldstep) {
//       backBtn.addEventListener("click", function () {
//         finalStep.style.display = "none";
//         oldstep.style.display = "block";
//       });
//     }
//   });
// });
// }

{
  document.addEventListener("DOMContentLoaded", function () {
    const contactForms = document.querySelectorAll(".contact-form");

    contactForms.forEach(function (form) {
      const nextBtnSpan = form.querySelector(".next-bttn span");
      const finalStep = form.querySelector(".final-step");
      const oldstep = form.querySelector(".your-contact-info");
      const backBtn = form.querySelector(".back_btns span");

      if (nextBtnSpan && finalStep && oldstep) {
        nextBtnSpan.addEventListener("click", function () {

          // Get all required fields from first step
          const requiredFields = oldstep.querySelectorAll(
            'input[required]'
          );

          let isValid = true;

          requiredFields.forEach(function (field) {

            // Check radio buttons
            if (field.type === "radio") {
              const radioGroup = oldstep.querySelectorAll(
                `input[name="${field.name}"]`
              );

              const checked = Array.from(radioGroup).some(
                radio => radio.checked
              );

              if (!checked) {
                isValid = false;
              }

            } else {
              // Check normal inputs
              if (field.value.trim() === "") {
                isValid = false;
                field.classList.add("error-show");
              } else {
                field.classList.remove("error-show");
              }
            }

            if (field.type === "radio") {

                const radioGroup = oldstep.querySelectorAll(
                  `input[name="${field.name}"]`
                );

                const checked = Array.from(radioGroup).some(
                  radio => radio.checked
                );

                radioGroup.forEach(function (radio) {
                  const parent = radio.closest(".location-radio");

                  if (!checked) {
                    parent.classList.add("error-show");
                    isValid = false;
                  } else {
                    parent.classList.remove("error-show");
                  }
                });

              }
          });


          
          // Stop going next if fields empty
          if (!isValid) {
            return;
          }

          // Open second step
          finalStep.style.display = "flex";
          oldstep.style.display = "none";
        });
      }

      if (backBtn && finalStep && oldstep) {
        backBtn.addEventListener("click", function () {
          finalStep.style.display = "none";
          oldstep.style.display = "block";
        });
      }
    });
  });
}


// PDP JS SLIDES
document.addEventListener("DOMContentLoaded", function () {
  var swiper = new Swiper(".thumbnails_slides", {
    spaceBetween: 10,
    slidesPerView: 3,
    watchSlidesProgress: true,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
  });
  var swiper2 = new Swiper(".media_main_slides", {
    loop: true,
    spaceBetween: 10,
    thumbs: {
      swiper: swiper,
    },
  });
});

// PDP JS SLIDES
